export const selectorExportUnderOverDepreciationReport = (state: any) => {
  return {
    loading: state.getIn(['accounting', 'underOverDepreciationReport', 'export', 'loading']),
  }
}
